import { defineStore } from 'pinia';
import { axios } from '../axios';

export const useUserStore = defineStore('user', {
  state: () => ({
    userDetails: null,
    loadingUserDetails: false,

    profesionales: [],
    loadingProfesionales: false,
  }),

  getters: {
    isUserLoading: state => state.loadingUserDetails,
    isProfesionalesLoading: state => state.loadingProfesionales,
  },

  actions: {
    async fetchUserDetails() {
      this.loadingUserDetails = true;
      try {
        const { data } = await axios.get('userdetails/');
        this.userDetails = data;
      } catch (err) {
        console.error('Error al obtener los detalles del usuario:', err);
        this.userDetails = null;
      } finally {
        this.loadingUserDetails = false;
      }
    },

    async fetchProfesionales() {
      this.loadingProfesionales = true;
      try {
        const { data } = await axios.get('profesionales/');
        this.profesionales = data;
      } catch (err) {
        console.error('Error al obtener los profesionales:', err);
        this.profesionales = [];
      } finally {
        this.loadingProfesionales = false;
      }
    },
  },
});
